var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#34DAE2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "print",
    transform: "translate(-0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    className: "st0",
    d: "M16.96,3.9V2.97c0-1.61-1.3-2.91-2.91-2.91H6.91C5.3,0.06,4,1.36,4,2.97V3.9H16.96z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    className: "st0",
    d: "M5.16,12.45v6.33c0,0.64,0.52,1.16,1.16,1.16l0,0h8.31c0.64,0,1.16-0.52,1.16-1.16l0,0v-6.33 H5.16z M12.03,17.42H8.92c-0.32,0-0.58-0.26-0.58-0.58c0-0.32,0.26-0.58,0.58-0.58l0,0h3.11c0.32,0,0.58,0.26,0.58,0.58 C12.61,17.16,12.35,17.42,12.03,17.42L12.03,17.42z M12.03,14.93H8.92c-0.32,0-0.58-0.26-0.58-0.58c0-0.32,0.26-0.58,0.58-0.58l0,0 h3.11c0.32,0,0.58,0.26,0.58,0.58C12.61,14.67,12.35,14.93,12.03,14.93L12.03,14.93z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    className: "st0",
    d: "M17.51,5.07H3.49c-1.61,0-2.91,1.3-2.91,2.91v4.66c0,1.61,1.3,2.91,2.91,2.91H4v-3.11H3.65 c-0.32,0-0.58-0.26-0.58-0.58c0-0.32,0.26-0.58,0.58-0.58h13.67c0.32,0,0.58,0.26,0.58,0.58c0,0.32-0.26,0.58-0.58,0.58h-0.35v3.11 h0.54c1.61,0,2.91-1.3,2.91-2.91V7.98C20.42,6.37,19.12,5.07,17.51,5.07z M5.51,8.72H3.65c-0.32,0-0.58-0.26-0.58-0.58 c0-0.32,0.26-0.58,0.58-0.58h1.86c0.32,0,0.58,0.26,0.58,0.58C6.09,8.46,5.83,8.72,5.51,8.72L5.51,8.72z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptPrint);
export default __webpack_public_path__ + "static/media/recrypt_print.4fc77582.svg";
export { ForwardRef as ReactComponent };